export const POPULATE = 'LandingZoneServicesPopulate'

export const SET_LOADED = 'LandingZoneServicesSetLoaded'

export const SET_FORMAT = 'LandingZoneServicesSetFormat'